import React, { useCallback, useContext, useMemo } from 'react';
import {
  CloseSquareOutlined,
  HistoryOutlined,
  LogoutOutlined,
  PrinterOutlined,
  ShopOutlined,
  StockOutlined,
} from '@ant-design/icons';
import { logout, useUserData } from '~/utils/auth';
import { Divider, Menu, MenuProps } from 'antd';
import { useNavigate } from 'react-router-dom';
import { DrawerContext } from '~/providers/DrawerProvider';
import './style.css';
import { useAtomValue, useSetAtom } from 'jotai';
import { restaurantAtom, selectRestaurantShowAtom } from '~/store/restaurant';
import { useCheckPermission } from '~/store/permission';

type MenuItem = Required<MenuProps>['items'][number];

const Sidebar = ({ closeDrawer }: { closeDrawer: () => void }) => {
  const user = useUserData();
  const navigate = useNavigate();
  const setSelectRestaurantShow = useSetAtom(selectRestaurantShowAtom);
  const restaurant = useAtomValue(restaurantAtom);

  const checkPermission = useCheckPermission();

  const items: MenuItem[] = useMemo(() => {
    const items: MenuItem[] = [];
    if (checkPermission('cashierBalancing:c')) {
      items.push({
        key: 'close-cashier',
        icon: <CloseSquareOutlined />,
        label: 'Tutup Kasir',
        onClick: () => {
          navigate('/cashier/close');
          closeDrawer();
        },
      });
    }

    if (checkPermission('order:r')) {
      items.push({
        key: 'order-history',
        icon: <HistoryOutlined />,
        label: 'Histori Order',
        onClick: () => {
          navigate('/order/history');
          closeDrawer();
        },
      });
    }

    // if (checkPermission('cashierTransaction:r')) {
    //   items.push({
    //     key: 'cashier-transaction',
    //     icon: <HistoryOutlined />,
    //     label: 'Histori Transaksi Kasir',
    //     onClick: () => {
    //       navigate('/cashier-transaction');
    //       closeDrawer();
    //     },
    //   });
    // }

    if (checkPermission('cashierBalancing:r')) {
      items.push({
        key: 'close-cashier-history',
        icon: <HistoryOutlined />,
        label: 'History Tutup Kasir',
        onClick: () => {
          navigate('/cashier/close/history');
          closeDrawer();
        },
      });
    }

    if (checkPermission('menuAvailability:c')) {
      items.push({
        key: 'menu-availability',
        icon: <StockOutlined />,
        label: 'Menu Availability',
        onClick: () => {
          navigate('/menu-availability');
          closeDrawer();
        },
      });
    }

    items.push(
      {
        key: 'setup-printer',
        icon: <PrinterOutlined />,
        label: 'Setup Printer',
        onClick: () => {
          navigate('/printers');
          closeDrawer();
        },
      },
      {
        key: 'restaurant',
        icon: <ShopOutlined />,
        label: 'Setup Restoran',
        onClick: () => {
          setSelectRestaurantShow(true);
          closeDrawer();
        },
      },
      {
        key: 'logout',
        icon: <LogoutOutlined />,
        label: 'Logout',
        onClick: () => {
          closeDrawer();
          logout();
        },
      }
    );
    return items;
  }, [checkPermission]);

  return (
    <div>
      <div className="p-4 flex flex-col">
        <div className="text-lg">
          {/* <UserOutlined style={{ marginRight: 8 }} /> */}
          <span>{user?.name}</span>
        </div>
        <p className="mb-0">{restaurant?.name}</p>
      </div>
      <Divider style={{ margin: 0 }} />
      <Menu items={items} />
    </div>
  );
};

export const useOpenSidebar = () => {
  const { openDrawer } = useContext(DrawerContext);

  return useCallback(() => {
    openDrawer(
      ({ closeDrawer }) => {
        return <Sidebar closeDrawer={closeDrawer} />;
      },
      {
        placement: 'right',
        width: '70%',
        bodyStyle: { padding: 0 },
      }
    );
  }, []);
};
